/** The case history's "view as at" control and the chain-verification banner (Phase 2 P2-1). */
export default {
  history: {
    viewAsAt: 'View as at this point',
    viewAsAtSeq: 'View as at this point (event #{{seq}})',
    viewingAsAt: 'As at event #{{seq}}, {{time}}',
    viewingAsAtSeq: 'As at event #{{seq}}',
    backToCurrent: 'Back to the current case',
    chainProven: 'Chain-proven',
    notChainProven: 'Not chain-proven',
    notChainProvenHint:
      'The history up to this point no longer verifies, or some files or check reports at this point were recorded before the history held their digests, or no longer match them.',
    stage: 'Stage',
    revision: 'Revision',
    title: 'Title',
    documents: 'Files at this point',
    submissions: 'Check results at this point',
    none: 'None',
    reused: 'reused',
    loadFailed: 'This point in the history could not be loaded.',
    loading: 'Loading this point in the history…',
  },
  chain: {
    broken:
      "This submission's history failed verification at event #{{seq}} (checked {{time}}). Nothing has been changed. Contact support.",
  },
} as const
